// web-ctr/src/components/DropZone.jsx
// The upload drop zones from Signup.dc.html. Two voices: primary (the teal
// fleet-policy zone, LEADGEN Part 1's "first, larger, pre-focused" path) and
// secondary (the grey COI/logo zones). The zone renders idle → processing →
// whatever the caller decides; extraction itself is the caller's problem.
import { useRef } from 'react';
import Spinner from '@/components/ui/Spinner.jsx';

export default function DropZone({ primary = false, title, sublabel, accept, capture, processing = false, processingLabel, processingSub, onFile }) {
  const inputRef = useRef(null);

  if (processing) {
    return (
      <div className="rounded-card-lg border-[1.5px] border-line bg-paper p-[22px_20px]">
        <div className="mb-3 flex items-center gap-3">
          <Spinner />
          <span className="text-[13.5px] font-semibold">{processingLabel}</span>
        </div>
        <div className="h-1.5 overflow-hidden rounded-pill bg-line">
          <div className="h-full w-[55%] rounded-pill bg-accent" />
        </div>
        {processingSub ? <div className="mt-2.5 text-xs text-ink-faint">{processingSub}</div> : null}
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        e.preventDefault();
        const f = e.dataTransfer?.files?.[0];
        if (f) onFile?.(f);
      }}
      className={primary
        ? 'w-full rounded-card-lg border-2 border-dashed border-teal-line bg-teal-faint p-[30px_22px] text-center leading-[1.6] hover:border-accent hover:bg-teal-fill'
        : 'w-full rounded-card border-[1.5px] border-dashed border-line-strong bg-paper p-[24px_18px] text-center text-[13px] leading-[1.6] text-ink-dim hover:border-accent'}
    >
      <span className={primary ? 'block text-[15px] font-bold text-primary' : 'block'}>{title}</span>
      {sublabel ? (
        <span className={primary ? 'mx-auto mt-1 block max-w-[440px] text-[12.5px] text-ink-dim' : 'mt-0.5 block text-[11.5px] text-ink-faint'}>
          {sublabel}
        </span>
      ) : null}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        // Mobile camera capture for photos of dec pages / COIs (spec Part 2).
        {...(capture ? { capture } : {})}
        className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; if (f) onFile?.(f); e.target.value = ''; }}
      />
    </button>
  );
}
